import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const UserManagementContent = lazy(() => import('./UserManagementContent'));



const UserManagement = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <UserManagementContent />
        </Suspense>
    );
}

export default UserManagement;